export default "__VITE_ASSET__BpSGjO$7__"